import React, { useState } from 'react';
import Button from '../Button';
import Input from '../form/Input';
import Select from '../form/Select';
import { TableFilterBar, TableFilterGrid, TableFilterField } from '../table-filter';
import { cn } from '../cn';
import { CASH_FLOW_FILTER_OPTIONS, CASH_PAYMENT_METHOD_OPTIONS, CASH_STATUS_FILTER_OPTIONS, } from './constants';
import { resolveCashPeriodDateRange, validateCashCustomPeriod } from './periodUtils';
const PERIODS = [
    { value: 'today', label: 'Today' },
    { value: '7d', label: '7d' },
    { value: '30d', label: '30d' },
    { value: 'custom', label: 'Custom' },
];
export const PortalCashTransactionFiltersBar = ({ draft, onDraftChange, onApply, applying, hideFlowFilter, }) => {
    const [customError, setCustomError] = useState(null);
    const handlePeriodClick = (period) => {
        setCustomError(null);
        if (period === 'custom') {
            onDraftChange({ ...draft, period });
            return;
        }
        const dates = resolveCashPeriodDateRange(period, '', '');
        onDraftChange({ ...draft, period, dateFrom: dates.dateFrom, dateTo: dates.dateTo });
    };
    const handleApply = () => {
        if (draft.period === 'custom') {
            const err = validateCashCustomPeriod(draft.dateFrom, draft.dateTo);
            if (err) {
                setCustomError(err);
                return;
            }
        }
        setCustomError(null);
        onApply();
    };
    return (React.createElement(TableFilterBar, null,
        React.createElement("div", { className: "mb-3 flex flex-wrap items-center gap-2" },
            React.createElement("span", { className: "text-xs font-medium text-gray-600" }, "Period"),
            PERIODS.map((p) => (React.createElement("button", { key: p.value, type: "button", onClick: () => handlePeriodClick(p.value), className: cn('rounded-lg border px-3 py-1.5 text-sm font-medium transition', draft.period === p.value
                    ? 'border-orange-500 bg-orange-50 text-orange-800'
                    : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50') }, p.label))),
            draft.period === 'custom' ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "flex items-center gap-1.5" },
                    React.createElement("label", { htmlFor: "cash-ledger-date-from", className: "shrink-0 text-xs font-medium text-gray-600" }, "From"),
                    React.createElement(Input, { id: "cash-ledger-date-from", type: "date", value: draft.dateFrom, onChange: (e) => onDraftChange({ ...draft, dateFrom: e.target.value }), inputSize: "sm", className: "w-[9.5rem]" })),
                React.createElement("div", { className: "flex items-center gap-1.5" },
                    React.createElement("label", { htmlFor: "cash-ledger-date-to", className: "shrink-0 text-xs font-medium text-gray-600" }, "To"),
                    React.createElement(Input, { id: "cash-ledger-date-to", type: "date", value: draft.dateTo, onChange: (e) => onDraftChange({ ...draft, dateTo: e.target.value }), inputSize: "sm", className: "w-[9.5rem]" })))) : null,
            customError ? React.createElement("p", { className: "w-full text-xs text-red-600" }, customError) : null),
        React.createElement(TableFilterGrid, { columns: 4, gapClassName: "gap-3" },
            React.createElement(TableFilterField, { label: "Search", className: "xl:col-span-2" },
                React.createElement(Input, { value: draft.search, onChange: (e) => onDraftChange({ ...draft, search: e.target.value }), placeholder: "Transaction ID, buyer, reference\u2026", inputSize: "sm" })),
            !hideFlowFilter ? (React.createElement(TableFilterField, { label: "Flow" },
                React.createElement(Select, { value: draft.flow, onChange: (e) => onDraftChange({ ...draft, flow: e.target.value }), options: CASH_FLOW_FILTER_OPTIONS, selectSize: "sm", hidePlaceholder: true }))) : null,
            React.createElement(TableFilterField, { label: "Status" },
                React.createElement(Select, { value: draft.status, onChange: (e) => onDraftChange({
                        ...draft,
                        status: e.target.value,
                    }), options: CASH_STATUS_FILTER_OPTIONS, selectSize: "sm", hidePlaceholder: true })),
            React.createElement(TableFilterField, { label: "Payment method" },
                React.createElement(Select, { value: draft.paymentMethod, onChange: (e) => onDraftChange({
                        ...draft,
                        paymentMethod: e.target.value,
                    }), options: [{ value: '', label: 'All' }, ...CASH_PAYMENT_METHOD_OPTIONS], selectSize: "sm", hidePlaceholder: true })),
            React.createElement(TableFilterField, { label: " " },
                React.createElement(Button, { type: "button", onClick: handleApply, disabled: applying, size: "sm" }, "Apply")))));
};
